<h3 mat-dialog-title>Przekazywanie opłaty</h3>

<p>
  Wszystkie szczegóły wydatku <b>{{ data.description }}</b> zostaną przekazane do {{ data.targetEmail }}.
</p>

<p>Czy chcesz przekazać ten wydatek?</p>

<mat-dialog-actions align="start">
  <button mat-raised-button color="accent" [matDialogClose]="true">Przekaż</button>
  <button mat-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
